module.exports = __webpack_public_path__ + "static/share-2cd3fcf026278bb5fac79a21c40cb26e.jpg";